import { voidCert as voidCertAction } from 'Redux/modules/webChat/actions';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useVoidCert = () => {
  const {
    certification: { status, errors },
  } = useSelector(state => state.webChat.emc);
  const dispatch = useDispatch();

  const voidACert = useCallback(
    async id => {
      await dispatch(voidCertAction(id));
    },
    [dispatch],
  );

  return {
    voidACert,
    loading: status.voidMC === 0,
    error: errors.voidMC,
  };
};

export default useVoidCert;
